<script setup lang="ts">
import type { Crystallize } from '#shared/utils/crystallize-spec'

const props = defineProps<{
  variant: SingleProductVariant
  defaultOpen: boolean
  template?: Crystallize.SingleProductTemplate
}>()

const detailsRef = ref<HTMLDetailsElement>()

const { hash } = useRoute()
onMounted(() => {
  // Since the product catalogue is loaded on the client, we need to wait for the component to mount before opening the details
  // FIXME: Load catalogue on the server and do this check directly in the :open attribute
  if (detailsRef.value && hash === `#${props.variant?.isbn}`) {
    detailsRef.value.open = true
  }
})

const { style } = useMonoColorTheme(computed(() => {
  switch (props.variant.formats?.[0]) {
    case 'grunnbok': return ColorName.Blue10
    case 'arbeidsbok': return ColorName.Seagreen10
    case 'digitalressurs_elev': return  ColorName.Green10
    case 'lesebok': return ColorName.Violet10
    case 'digitalbok': return ColorName.Purple10
    case 'laerermateriell': return ColorName.Coral10
    case 'digitalressurs_laerer': return ColorName.Orange10
    default: return ColorName.Blue10
  }
}))
</script>

<template>
  <details
    :id="variant.isbn"
    ref="detailsRef"
    class="variant group bg-(--theme-10) mx-auto mb-1 rounded-sm text-black md:w-full"
    :open="defaultOpen"
    :style
  >
    <UiSingleProductSummary :variant="variant" />
    <UiSingleProductDetails :variant="variant" />
  </details>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.variant {
  --outer-padding: 0.75rem;
  padding: var(--outer-padding);

  @media screen and (min-width: theme('screens.sm')) {
    --outer-padding: 1.5rem;
    padding-inline: 1.25rem;
  }

  @media screen and (min-width: theme('screens.md')) {
    --outer-padding: 2rem;
    padding-inline: 3.75rem;
  }

  &:has(.preview:hover) {
    transition: all 0.2s ease;
    filter: brightness(90%);
  }
}
</style>
